import { PostHogProvider } from 'posthog-js/react'

import { POSTHOG_HOST, POSTHOG_KEY } from '@/config'
import { dropCloudProviderRequest } from '@/services/monitoring/cloudProviderPrivacy'

const POSTHOG_OPTIONS = {
  api_host: POSTHOG_HOST,
  session_recording: { maskCapturedNetworkRequestFn: dropCloudProviderRequest },
}

export default function TrackingProvider({
  children,
}: {
  children: React.ReactNode
}) {
  if (!POSTHOG_HOST || !POSTHOG_KEY) return <>{children}</>

  return (
    <PostHogProvider apiKey={POSTHOG_KEY} options={POSTHOG_OPTIONS}>
      {children}
    </PostHogProvider>
  )
}
